import type { CartEntryItem } from '#lib/features/checkout/types.js';
import type { CartItems } from '#lib/features/checkout/utils/createCartItemsStore/index.js';

export const getEditionsCartItemsFromOrder = (
	cartEntryItems: CartEntryItem[]
) => {
	return cartEntryItems.reduce((accumulator: CartItems, cartEntryItem) => {
		if (
			!cartEntryItem.productId ||
			!cartEntryItem.id ||
			!cartEntryItem.quantity
		) {
			return accumulator;
		}

		return {
			...accumulator,
			[cartEntryItem.productId]: {
				entityId: cartEntryItem.id,
				quantity: cartEntryItem.quantity,
				restricted: false,
				group: null,
				currency: null,
				price: null,
				name: null,
				sku: null,
				groupId: null,
				dropConfigId: null,
			},
		};
	}, {});
};
